
export const gaPackageBrowsePageLoad  = () => {
  if (window.jostensGASY25enabledPLP) return;
  window && !window.dataLayer && (window.dataLayer = []);
  let eventName = "";
  let packageType = "";
  switch(window.template) {
    case "COL-GRAD-ANNC":
      eventName = "COLAnnouncementsBrowsePageLoad";
      packageType = "COL Announcements";
      break;
    case "HS-GRAD":
      eventName = "packageBrowsePageLoad";
      packageType = "Grad";
      break;
    case "COL-GREG-PKG":
      eventName = "COLGradpackageBrowsePageLoad";
      packageType = "COL Grad";
      break;
  }
   

  window.dataLayer.push({
   "event": eventName,
   "pageType": window?.gaPageType +" Package Browse",
   "schoolType": window?.affiliationData?.customerClassCode,
   "schoolId": window?.affiliationData?.affiliateId,
   "schoolName": window?.affiliationData?.name,
   "packageOrderStepName":"Selection Page",
   "packageType": packageType
 });
};

export const gaPackageBrowseShopOrCustomizeClick  = (product, sectionOfPage) => {
  if (window.jostensGASY25enabledPLP) return;
  window && !window.dataLayer && (window.dataLayer = []);
  let eventName = "";
  let packageType = "";
  switch(window.template) {
    case "COL-GRAD-ANNC":
      eventName = "COLAnnouncementsCustomizeClick";
      packageType = "COL Announcements";
      break;
    case "HS-GRAD":
      eventName = "packageBrowseCustomizeClick";
      packageType = "Grad";
      break;
    case "COL-GREG-PKG":
      eventName = "COLGradPackageCustomizeClick";
      packageType = "COL Grad";
      if(sectionOfPage = "Banner"){
        eventName = "COLGradPackageShopNow";
      }
      break;
  }
  window.dataLayer.push({
  "event": eventName,
  "pageType": window?.gaPageType +" Package Browse",
  "schoolType": window?.affiliationData?.customerClassCode,
  "schoolId": window?.affiliationData?.affiliateId,
  "schoolName": window?.affiliationData?.name,
  "packageId": product?.productOsr,
  "packageOrderStepName":`Customize ${sectionOfPage} Button`,
  "packageType": packageType
});
};

export const gaPackageBrowselinkedSection  = (product, publishedCatalogProductId) => {
  if (window.jostensGASY25enabledPLP) return;
  window && !window.dataLayer && (window.dataLayer = []);
  let eventObj = {
    "event": window.template === "COL-GRAD-ANNC" ? "COLAnnouncementsPopUp":"COLAnnouncementsPopUpSelection",
    "pageType": window?.gaPageType +" Package Browse",
    "schoolType": window?.affiliationData?.customerClassCode,
    "schoolId": window?.affiliationData?.affiliateId,
    "schoolName": window?.affiliationData?.name,
    "packageId": product.productOsr,
    "packageOrderStepName":`Pop Up`,
    "packageType": window.template === "COL-GRAD-ANNC" ? "COL Announcements":"Grad"
  }
  publishedCatalogProductId && (eventObj["publishedCatalogProductId"] = publishedCatalogProductId);
  window.dataLayer.push(eventObj);
};
export const gaPackageBrowseFilterSelection  = (eventName, clickText) => {
  if (window.jostensGASY25enabledPLP) return;
  window && !window.dataLayer && (window.dataLayer = []);
  window.dataLayer.push({
  "event": eventName,
  "pageType": window?.gaPageType,
  "schoolType": window?.affiliationData?.customerClassCode,
  "schoolId": window?.affiliationData?.affiliateId,
  "schoolName": window?.affiliationData?.name,
  "ClickText": clickText,
  "packageType": "COL Grad"
});
};